<div class="gw-container">
    <form [formGroup]="remitenteForm">
        <div class="div-formback">
        </div>
        <div class="gw-flex-titulos">
            <div>
                <h4>Remitente</h4>
                <p class="gw-flex-titulo2">Sesión: {{this.doc.idsesion}} - {{this.tipopaquete}}</p>
            </div>
            <div>
                <button class="gw-btn-backpantalla" (click)="limpiar()" type="button">Limpiar</button>
            </div>
        </div>

        <div *ngIf="editingIddir" class="editing-banner">
            <span class="editing-text">
                <i class="fa-solid fa-pen-to-square"></i>
                Editando remitente guardado
            </span>
            <button type="button" class="btn-cancel-edit" (click)="cancelarEdicion()">
                Cancelar Edición <i class="fa-solid fa-xmark"></i>
            </button>
        </div>

        <div class="checkbox-wrapper-4" style="margin-bottom: 20px;">
            <input class="inp-cbx" id="guardarRemitentechkbox" type="checkbox" formControlName="guardarRemitente">
            <label class="cbx" for="guardarRemitentechkbox"><span>
                    <svg width="12px" height="10px">
                        <use xlink:href="#check-remitente"></use>
                    </svg></span><span>Guardar en lista de remitentes</span></label>
            <svg class="inline-svg">
                <symbol id="check-remitente" viewBox="0 0 12 10">
                    <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                </symbol>
            </svg>
        </div>

        <div class="div-form">
            <label class="lbl-text">Nombre</label>
            <div class="gw-flex-input-btn">
                <input class="doc-lbl" formControlName="nombre" id="nombre" maxlength="100" type="text" inputmode="text"
                    autocomplete="name"
                    [ngClass]="{validacion: (Rem.nombre.invalid || Rem.nombre.hasError('IsEmpty')) && submitted}">
                <button type="button" class="gw-btn-orange-icon" (click)="abrirModalDirectorio()">
                    <i class="fa-solid fa-address-book"></i>
                    <span class="btn-text">Directorio</span>
                </button>
            </div>
            <div class="val-valido" [ngClass]="{invalido: (Rem.nombre.invalid)  && submitted}">* Introduce el nombre
            </div>
        </div>

        <!-- Rest of the form remains unchanged ... -->

        <div class="gw-flex">
            <div class="gw-flex-l">
                <label class="lbl-text">Estado</label>
                <div class="select">
                    <select id="pais" formControlName="selectEstado"
                        [ngClass]="{validacion: (Rem.selectEstado.invalid || Rem.selectEstado.hasError('isEmpty')) && submitted}"
                        required (change)="estadoChanged($event.target.value)">
                        <option value="" disabled selected class="option s">Seleccione</option>
                        <option *ngFor="let i of estado" [value]="i.idedo">
                            {{ i.estado }}
                        </option>
                    </select>
                </div>
                <div class="val-valido" [ngClass]="{invalido: (Rem.selectEstado.invalid)  && submitted}">* Introduce el
                    estado
                </div>
            </div>
            <div class="gw-flex-r">
                <label class="lbl-text">Ciudad</label>
                <div class="select">
                    <select id="pais" formControlName="selectCiudad"
                        [ngClass]="{validacion: (Rem.selectCiudad.invalid || Rem.selectCiudad.hasError('isEmpty')) && submitted}"
                        required (change)="ciudadChanged($event.target.value)">
                        <option value="" disabled selected class="option s">Seleccione</option>
                        <option *ngFor="let i of ciudad" [value]="i.idcd">
                            {{ i.ciudad }}
                        </option>
                    </select>
                </div>
                <div class="val-valido" [ngClass]="{invalido: (Rem.selectCiudad.invalid)  && submitted}">* Introduce la
                    ciudad
                </div>
            </div>
        </div>

        <div class="gw-flex">
            <label class="lbl-text" style="position:absolute">Entrega</label>
            <div class="gw-flex-l" style="display: flex; align-items: center; padding-top: 12px">
                <div class="checkbox-wrapper-4">
                    <input class="inp-cbx" id="sucursalchkbox" type="checkbox" formControlName="sucursalSeleccionado"
                        (click)="imprimirEstadoCheckboxes('sucursalSeleccionado')">
                    <label class="cbx" for="sucursalchkbox"><span>
                            <svg width="12px" height="10px">

                            </svg></span><span>Sucursal</span></label>
                    <svg class="inline-svg">
                        <symbol id="check-4" viewBox="0 0 12 10">
                            <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                        </symbol>
                    </svg>
                </div>
                <div class="checkbox-wrapper-4">
                    <input class="inp-cbx" id="recoleccionchkbox" type="checkbox"
                        formControlName="recoleccionSeleccionado"
                        (click)="imprimirEstadoCheckboxes('recoleccionSeleccionado')">
                    <label class="cbx" for="recoleccionchkbox"><span>
                            <svg width="12px" height="10px">

                            </svg></span><span>Recolección</span></label>
                    <svg class="inline-svg">
                        <symbol id="check-4" viewBox="0 0 12 10">
                            <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                        </symbol>
                    </svg>
                </div>
            </div>

            <div class="gw-flex-r">
                <label class="lbl-text">Colonia</label>
                <div class="select">
                    <select id="pais" formControlName="selectColonia"
                        [ngClass]="{validacion: (Rem.selectColonia.invalid || Rem.selectColonia.hasError('isEmpty')) && submitted}"
                        required (change)="coloniaChanged($event.target.value)">
                        <option value="" disabled selected class="option s">Seleccione</option>
                        <option *ngFor="let i of colonia" [value]="i.idcol">
                            {{ i.colonia }}
                        </option>
                    </select>
                </div>
                <div class="val-valido" [ngClass]="{invalido: (Rem.selectColonia.invalid)  && submitted}">* Introduce la
                    colonia
                </div>
            </div>
        </div>

        <div class="div-form">
            <label class="lbl-text">Direccíon</label>
            <input id="direccion" formControlName="direccion" type="text" inputmode="text" autocomplete="street-address"
                maxlength="200"
                [ngClass]="{validacion: (Rem.direccion.invalid || Rem.direccion.hasError('IsEmpty')) && submitted}">
            <div class="val-valido" [ngClass]="{invalido: (Rem.direccion.invalid)  && submitted}">* Introduce una
                direccíon
            </div>
        </div>
        <div class="gw-flex">
            <div class="gw-flex-l">
                <label class="lbl-text">Teléfono</label>
                <input formControlName="telefono" required (keydown)="cambiarFocus($event)" maxlength="10"
                    minlength="10" type="text" inputmode="tel" autocomplete="tel"
                    [ngClass]="{validacion: (Rem.telefono.invalid || Rem.telefono.hasError('IsEmpty')) && submitted}">
                <div class="val-valido"
                    [ngClass]="{invalido: (Rem.telefono.invalid && Rem.telefono.value == '' )  && submitted}">* Intenta
                    con un teléfono valido
                </div>
                <div class="val-valido"
                    [ngClass]="{invalido: (Rem.telefono.value != '' && Rem.telefono.invalid)  && submitted}">* Solo
                    puedes ingresar 10 dígitos
                </div>
            </div>

            <div class="gw-flex-r">
                <label class="lbl-text">Código postal</label>
                <input type="text" formControlName="cp"
                    [ngClass]="{validacion: (Rem.cp.value == null || Rem.cp.invalid || Rem.cp.hasError('IsEmpty')) && submitted}">
            </div>
        </div>
        <div class="gw-reverse-btn">
            <button name="Aceptar" class="gw-btn-continuar gw-btn-pasos" type="submit"
                (click)="guardarsesion_paso2()">{{ remitenteForm.get('guardarRemitente')?.value ? 'Guardar y continuar' : 'Continuar' }}</button>
            <button class="btn-back gw-btn-pasos" type="button" (click)="regresarMenu()">Regresar</button>
        </div>
    </form>
</div>

<!-- MODAL DIRECTORIO -->
<div class="gw-modal-overlay" *ngIf="showModalDirectorio" (click)="cerrarModalDirectorio()">
    <div class="gw-modal-content" (click)="$event.stopPropagation()">
        <div class="gw-modal-header">
            <div class="header-titles">
                <h3>Directorio de Remitentes</h3>
                <p class="header-subtitle">Selecciona el remitente que desea capturar</p>
            </div>
            <button class="gw-close-btn" (click)="cerrarModalDirectorio()">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
        <div class="gw-modal-body">
            <!-- CONTROLES DIRECTORIO -->
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; gap: 15px;">
                <!-- BUSCADOR -->
                <div class="gw-search-container" style="margin-bottom: 0; flex: 1;">
                    <i class="fa-solid fa-magnifying-glass"></i>
                    <input type="text" [(ngModel)]="searchTerm" (input)="filtrarRemitentes()"
                        placeholder="Buscar remitente...">
                </div>
            </div>

            <!-- VISTA MOBILE (CARDS) -->
            <div class="gw-mobile-view">
                <div class="gw-remitente-grid">
                    <div class="gw-remitente-card" *ngFor="let rem of listaRemitentesFiltrada"
                        (click)="seleccionarRemitente(rem)">
                        <div class="card-selection-indicator">
                            <i class="fa-solid fa-check"></i>
                        </div>
                        <div class="card-icon">
                            <i class="fa-solid fa-user"></i>
                        </div>
                        <div class="card-info">
                            <h4 class="rem-nombre">{{rem.nombre}}</h4>
                            <p class="rem-detalle"><i class="fa-solid fa-location-dot"></i> {{rem.direccion}}, Col.
                                {{rem.coloniaNombre}}</p>
                            <p class="rem-detalle"><i class="fa-solid fa-city"></i> {{rem.ciudadNombre}},
                                {{rem.estadoNombre}}</p>
                            <p class="rem-detalle"><i class="fa-solid fa-phone"></i> {{rem.tel}}</p>
                            <div class="card-actions-row">
                                <button type="button" class="btn-action-card edit" (click)="editarRemitente(rem, $event)">
                                    <i class="fa-solid fa-pen"></i> Editar
                                </button>
                                <button type="button" class="btn-action-card delete" (click)="eliminarRemitente(rem, $event)">
                                    <i class="fa-solid fa-trash"></i> Eliminar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- VISTA DESKTOP (TABLA) -->
            <div class="gw-desktop-view">
                <table class="gw-remitente-table">
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Estado</th>
                            <th>Ciudad</th>
                            <th>Colonia</th>
                            <th>Dirección</th>
                            <th>Teléfono</th>
                            <th style="width: 90px; text-align: center;">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let rem of listaRemitentesFiltrada" (click)="seleccionarRemitente(rem)">
                            <td class="td-nombre">{{rem.nombre}}</td>
                            <td>{{rem.estadoNombre}}</td>
                            <td>{{rem.ciudadNombre}}</td>
                            <td>{{rem.coloniaNombre}}</td>
                            <td>{{rem.direccion}}</td>
                            <td>{{rem.tel}}</td>
                            <td class="td-action-buttons">
                                <button type="button" class="btn-action-table edit" (click)="editarRemitente(rem, $event)" title="Editar">
                                    <i class="fa-solid fa-pen"></i>
                                </button>
                                <button type="button" class="btn-action-table delete" (click)="eliminarRemitente(rem, $event)" title="Eliminar">
                                    <i class="fa-solid fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>